export const REGISTER_IMPRESSION_ITEM_EVENT = 'register_impression_item_event';
export const SEND_IMPRESSION_EVENT = 'send_impression_event';
const ITEM_REGISTERED_IN_MANAGER_EVENT = 'item_registered_in_manager_event';
export const getItemRegisteredInManagerEvent = (itemId) => `${ITEM_REGISTERED_IN_MANAGER_EVENT}_${itemId}`;
export const SECTION = {
    HEADER: 'header',
    TOP: 'top',
    CENTER: 'center',
    BOTTOM: 'bottom',
    RIGHT_SIDE_BAR: 'right-side-bar',
    LEFT_SIDE_BAR: 'left-side-bar'
};
export const MANAGER_ID = 'impression-manager';
export const MANAGER_ELEMENT = (typeof document !== 'undefined') ? document.body : null;
